import React from 'react'

function UploadIcon() {
    return (
        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_3642_36212)">
                <path d="M20 25C20 22.2386 22.2386 20 25 20H57C59.7614 20 62 22.2386 62 25V57C62 59.7614 59.7614 62 57 62H25C22.2386 62 20 59.7614 20 57V25Z" fill="white" />
                <g clipPath="url(#clip0_3642_36212)">
                    <path d="M37.4669 36.5423L39.7843 34.2241L39.8018 45.5836C39.8018 46.2739 40.3615 46.8335 41.0518 46.8335C41.7421 46.8335 42.3017 46.2739 42.3017 45.5836L42.2842 34.2382L44.5883 36.5423C45.0679 37.0389 45.8592 37.0526 46.3557 36.573C46.8523 36.0934 46.866 35.3021 46.3864 34.8056C46.3764 34.7952 46.3661 34.7849 46.3557 34.7749L43.6792 32.0983C42.2148 30.6339 39.8405 30.6339 38.3761 32.0983L38.376 32.0983L35.6995 34.7749C35.2199 35.2714 35.2337 36.0627 35.7302 36.5423C36.2146 37.0101 36.9826 37.0101 37.4669 36.5423Z" fill="#2820DA" />
                    <path d="M49.7497 43.0859C49.0594 43.0859 48.4997 43.6456 48.4997 44.3359V48.1615C48.4993 48.3496 48.347 48.5019 48.1589 48.5023H33.8412C33.6531 48.5019 33.5008 48.3496 33.5004 48.1615V44.3359C33.5004 43.6456 32.9408 43.0859 32.2504 43.0859C31.5601 43.0859 31.0005 43.6456 31.0005 44.3359V48.1615C31.0023 49.7297 32.2731 51.0004 33.8412 51.0022H48.1589C49.727 51.0004 50.9978 49.7296 50.9996 48.1615V44.3359C50.9996 43.6456 50.44 43.0859 49.7497 43.0859Z" fill="#2820DA" />
                </g>
            </g>
            <defs>
                <filter id="filter0_d_3642_36212" x="0" y="0" width="82" height="82" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3642_36212" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3642_36212" result="shape" />
                </filter>
                <clipPath id="clip0_3642_36212">
                    <rect width="20" height="20" fill="white" transform="translate(31 31)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default UploadIcon